import React from "react";
import { useSelector } from "react-redux";

import MultiSelectFollowUp from "./MultiSelectFollowUp";
import { StateType, FollowUpProps } from "./types";
import GuidedTextarea from "./GuidedTextarea";

const FollowUp = ({ follow_up_options: followUpOptions, ...props }: FollowUpProps) => {
    const selfIdentifyOff = useSelector<StateType, boolean>(
        (state) => !!state.company?.settings?.retain?.self_identify_off,
    );

    if (followUpOptions?.options?.length) {
        return <MultiSelectFollowUp follow_up_options={followUpOptions} {...props} />;
    }

    return (
        <GuidedTextarea
            follow_up_options={followUpOptions}
            selfIdentifyOff={selfIdentifyOff}
            {...props}
        />
    );
};

export default React.memo(FollowUp);
